export const SELECTION_UNIT_PIECE = "pz";
export const SELECTION_UNIT_KG = "kg";
export const KG_QUANTITY_STEP = 0.1;
